import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  container: {
    height: '100%',
  },
  actionBar: {
    zIndex: 3,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
  },
  containerTabs: {
    paddingTop: '112px',
  },
});

export default styles;
